import React from 'react';

import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import InventoryMonitorsEdit from '@shared/inventory_monitors/InventoryMonitorsEdit';
import { useParams } from 'react-router-dom';

import { inventoryMonitorService } from '@services/admin/inventoryMonitorService';
import { productService } from '@services/admin/productService';

const AdminInventoryMonitorsEdit: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { currentMerchant } = useMerchant();
  const { inventoryTypes, loading } = useMerchantData()!;

  // Admin session 鎖單一 merchant；merchantIdForCreate 雖然 edit 模式用不到，
  // 但保持與 operator 一致的 prop 注入，shared 只在新增模式時讀取。
  return (
    <InventoryMonitorsEdit
      inventoryMonitorService={inventoryMonitorService}
      productService={productService}
      inventoryTypes={inventoryTypes as any[]}
      inventoryMonitorId={id}
      merchantIdForCreate={currentMerchant?.id ?? null}
      merchantDataLoading={Boolean(loading)}
    />
  );
};

export default AdminInventoryMonitorsEdit;
